import store from '@/store';
import { ADD_MESSAGE_STATUS } from '@/store/mutation-types.js';

export default class ManualCallStatusEvent {
  constructor(body) {
    console.log('%c [event]', 'color: #F44336;', JSON.stringify(body, null, 4));

    let sipCause = body.sipcause.split(' ')[1];
    if (sipCause == '404') {
      store.dispatch('voice/addErrorVoiceMessage', true);
      store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'NOTFOUNDED');
      return;
    }
    if (sipCause == '408') {
      store.dispatch('voice/addErrorVoiceMessage', true);
      store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'NOTANSWERED');
      return;
    }

    switch (body.status) {
      case 'Blacklist':
        store.dispatch(
          'showSnackbar',
          { text: 'contactInBlacklist', type: 'success' },
          { root: true },
        );
        break;
      case 'BUSY':
        store.dispatch('voice/addErrorVoiceMessage', true);
        store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'BUSY');
        // store.dispatch('showSnackbar', { text: 'Destinatário ocupado. Tente novamente mais tarde.', type: 'success' }, { root: true })
        break;
      case 'NOANSWER':
        store.dispatch('voice/addErrorVoiceMessage', true);
        store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'NOANSWER');
        // store.dispatch('showSnackbar', { text: 'Destinatário não atende. Tente novamente mais tarde.', type: 'success' }, { root: true })
        break;
      case 'CANCEL':
        store.dispatch('voice/addErrorVoiceMessage', true);
        store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'CANCEL');
        // store.dispatch('showSnackbar', { text: 'Destinatário cancelou a ligação', type: 'success' }, { root: true })
        break;
      case 'CHANUNAVAIL':
        store.dispatch('voice/addErrorVoiceMessage', true);
        store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'CHANUNAVAIL');
        // store.dispatch('showSnackbar', { text: 'Não foi possível acionar o telefone especificado. Tente novamente', type: 'success' }, { root: true })
        break;
      case 'CONGESTION':
        store.dispatch('voice/addErrorVoiceMessage', true);
        store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'CONGESTION');
        store.dispatch(
          'showSnackbar',
          {
            text: 'Não foi possível completar sua chamada, verifique o problema com sua operadora. Tente novamente',
            type: 'success',
          },
          { root: true },
        );
        break;
      case 'UNAVAILABLE':
        store.dispatch('voice/addErrorVoiceMessage', true);
        store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'UNAVAILABLE');
        break;
      case 'INVALIDNUMBER':
        store.dispatch('voice/addErrorVoiceMessage', true);
        store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'INVALIDNUMBER');
        break;
      case 'REJECTED':
        store.dispatch('voice/addErrorVoiceMessage', true);
        store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'REJECTED');
        break;
    }
  }
}
